<ux-avatar
  class="avatar-select__avatar"
  [user]="currentUser()"
  [showDeleteBtn]="true"
  (remove)="remove.emit()"
  (click)="onTogglePopup($event)"
>
</ux-avatar>

@if (isPopupOpen()) {
  <ux-popup-user
    class="avatar-select__popup"
    [projectId]="projectId()"
    [ngStyle]="popupStyles()"
    [value]="currentValue()"
    (selectItem)="selectUser($event)"
    (clickOutside)="closePopup()"
    [delayClickOutsideInit]="true"
  >
  </ux-popup-user>
}
